import { html } from "lit-element";
import { StatefulModule } from "../../ModuleBase/ModuleMetadata";
import '../../../../elements/color-picker';
export class DrawLinesModule extends StatefulModule {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.canvas.on("mouse:down", this.startLine);
		this.canvas.on("mouse:up", this.endLine);
		this.canvas.on("mouse:move", this.moveLine);
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.startLine);
		this.canvas.off("mouse:up", this.endLine);
		this.canvas.off("mouse:move", this.moveLine);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	render() {
		return html`
        <style>
			:host {
				padding: 5px;
				width: 100%;
				cursor: pointer; 
			}
			svg {
				cursor: pointer;
				width: 100%;
				height: 100%;
			}
        </style>
        <label>${this.icon}</label>`;
	}

	static get properties() {
		return { activeLine: String };
	}

	RenderSettings(obj, closeFunc) {
		const currentSettings = obj.moduleState;
		let tempWidth = currentSettings.width;
		let tempLineColor = currentSettings.stroke || obj.stroke;

		const applyFunc = () => {
			this.applyNewSettings(obj, tempWidth, tempLineColor);
			closeFunc();
		};

		return html`
            <style>
                .title {
                    font-size: x-large;    
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .button-box {
                    display: flex;
                    margin-top: 20px;
                }
                .cPick{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: var(--secondary-color-variant1);
                }
            </style>
 
            <div class="title">Line settings</div>    
            <div> 
                <text-box type="text" label="Width" 
                    @change="${e => (tempWidth = e.currentTarget.value)}"
                    .value="${currentSettings.width}"></text-box>
            </div>
            	<div class="cPick">
                    <label for="lColor">Line color</label>
                    
                    <color-picker name="lColor" .value="${tempLineColor}" @change="${(e) => tempLineColor = e.detail}" ></color-picker>

				
                </div>                
         

            <div class="button-box">
                <mwc-button @click="${closeFunc}" label="Close"></mwc-button>
                <mwc-button @click="${applyFunc}" label="Apply"></mwc-button>
            </div>`;
	}

	applyNewSettings(obj, width, stroke) {
		const currentSettings = obj.moduleState;
		if (currentSettings.width == width &&
            currentSettings.stroke == stroke) return;

		this.addMetadata(obj, { width: Number(width), stroke });
		obj.set({ strokeWidth: Number(width), stroke });
		this.canvas.renderAll();
		this.canvas.trigger("object:modified", { target: obj });
	}

	constructor(canvas, getColor, name, icon, drawingHistory) {
		super();

		this.canvas = canvas;
		this._getColor = getColor;
		this.name = name;
		this.icon = icon;
		this.width = 5;
		this.drawingHistory = drawingHistory;

		this.startLine = o => {
			this.drawingHistory.pause();
			this.isDown = true;
			var pointer = this.canvas.getPointer(o.e);
			var points = [pointer.x, pointer.y, pointer.x, pointer.y];

			var opts = {
				selectable: false,
				strokeWidth: this.width,
				strokeDashArray: [0, 0],
				fill: this._getColor(),
				stroke: this._getColor(),
				originX: "center",
				originY: "center"
			};

			switch (this.name) {
				case "arrow":
					this.line = new fabric.LineArrow(points, opts);
					break;
				case "arrow2":
					this.line = new fabric.LineTwoArrow(points, opts);
					break;
				case "dotted":
					this.line = new fabric.Line(points, {
						...opts,
						strokeDashArray: [5, 5]
					});
					break;
				case "dashed":
					this.line = new fabric.Line(points, {
						...opts,
						strokeDashArray: [20, 5]
					});
					break;
				case "straight":
				default:
					this.line = new fabric.Line(points, opts);
					break;
			}
			this.canvas.add(this.line);
		};

		this.moveLine = o => {
			if (!this.isDown) return;

			var pointer = this.canvas.getPointer(o.e);
			this.line.set({
				x2: pointer.x,
				y2: pointer.y
			});
			this.canvas.renderAll();
		};

		this.endLine = () => {
			this.isDown = false;
			this.canvas.remove(this.line);

			if (!this.line) return;

			const xDiff = this.line.x2 - this.line.x1;
			const yDiff = this.line.y2 - this.line.y1;

			const mod = n => {
				return n ? ((this % n) + n) % n : 0;
			};

			if (mod(xDiff) < this.line.strokeWidth && mod(yDiff) < this.line.strokeWidth) return;
            
			this.drawingHistory.unpause();
			this.canvas.add(this.line);
			this.addMetadata(this.line, { width: this.width });

			this.line = null;
			this.canvas.renderAll();
		};
	}
}

window.customElements.define("inspx-draw-lines-module", DrawLinesModule);
